import React,{Component} from "react";
import { Container, Row, Col, Card, CardHeader, CardBody, 
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormSelect,

   } from "shards-react";

import PageTitle from "../common/PageTitle";
import { Redirect } from 'react-router';
import '../style.css'
import { AtomSpinner } from 'react-epic-spinners';
import { toast } from 'react-toastify';
import firebase from '../firebase';
import ModifyResult from './ModifyResult';
import ResultTable from './ResultTable';

export default class Student extends Component{

    constructor(props) {
      super(props);
    
      this.state = {
                    modify_result:false,
                    loading:false,
                    class_list:[],
                    exam_data:[],
                    exam_list:[],
                    subjects:[],
                    selected_class:"Select Class",
                    selected_exam:"Select Exam Type",
                    results_data : [],
                    modify_result_data:undefined,
                    logged_in:false,
                  };


      this.ShowViewResult = this.ShowViewResult.bind(this);
      this.ShowModifyResult = this.ShowModifyResult.bind(this);
      this.get_class_list = this.get_class_list.bind(this);
      this.get_exam_data = this.get_exam_data.bind(this);
      this.onExamChange = this.onExamChange.bind(this);
      this.get_subjects = this.get_subjects.bind(this);
      this.onClassChange = this.onClassChange.bind(this);
      this.get_results_data = this.get_results_data.bind(this);
      this.modify_result = this.modify_result.bind(this);
    }

    get_results_data = ()=>{

      if(this.state.selected_class==="Select Class" || this.state.selected_exam==="Select Exam Type"){
          console.log("Stopped Result");
          return;
      }

      console.log("Continuing to fetch...");
        var that = this; 
        var code = this.state.selected_exam+":"+this.state.selected_class;
        
        that.setState({loading:true,results_data:[]});
        firebase.firestore().collection('Results').doc(code).get().then(function(doc){
            if(doc.exists){
                console.log("Doc exists");
                console.log(doc.data());
                that.setState({loading:false,results_data:doc.data().results});
            }
            else{
              toast("No results Exist",{ContainerID:'A'});
              console.log("No Result Exists");
              that.setState({loading:false});
            }

        }).catch(function(err){
            that.setState({loading:false});
            console.log(err);
        })
    }

    get_subjects= (key,arr)=>{
          for(var i=0;i<arr.length;i++){
            if(key===arr[i].exam_name){
                return arr[i].subjects;
            }
          }
          return -1;
    }

    onExamChange = (value)=>{
        var subjects = this.get_subjects(value,this.state.exam_data);
        this.setState({selected_exam:value,subjects:subjects},this.get_results_data);
    }

    onClassChange = (value)=>{

          this.setState({selected_class:value},this.get_results_data);
    }

    get_exam_data = ()=>{

        var that = this;
        this.setState({loading:true});

        firebase.firestore().collection('Exam').get().then(function(snapshot){

            var exam_list = [];
            var exam_data = [];

            snapshot.forEach(function(doc){
                var data = doc.data();
                exam_list.push(data.exam_name);
                exam_data.push(data);
                that.setState({subjects:data.subjects}); //just for testing
            })
            console.log(exam_data,exam_list);
            that.setState({loading:false,exam_list:exam_list,exam_data:exam_data});
        }).catch(function(err){
            console.log(err);
            that.setState({loading:false});
        })
    }


     get_class_list = ()=>{
        var that = this;
        this.setState({loading:true});
        
        firebase.firestore().collection('ClassList').doc('list').get().then(function(doc){
          var class_list = doc.data().classes;
          class_list.shift();  //removes first element in array
          console.log(class_list);
          that.setState({loading:false,class_list:class_list});

        }).catch(function(err){
            console.log(err);
            that.setState({loading:false,class_list:[]})
        })
  }


    ShowViewResult = ()=>{
      console.log("View result");
      this.setState({modify_result:false});
    }
    
    ShowModifyResult = ()=>{
      this.setState({modify_result:true});
    }

    modify_result = (roll_no,name)=>{

        var modify_data = {
          class_name:this.state.selected_class,
          exam_name:this.state.selected_exam,
          result_data:this.state.results_data,
          subject_list:this.state.subjects,
          roll_no:roll_no, 
          name:name,
        }
        this.setState({modify_result_data:modify_data},this.ShowModifyResult);

    }

    componentDidMount(){
        this.get_class_list();
        this.get_exam_data();
    }

    get_current_exam_data = ()=>{
        var exam_name = this.state.selected_exam;
        var exam_data = this.state.exam_data;
        var n = exam_data.length;
        for(var i=0;i<n;i++){
            if(exam_name===exam_data[i].exam_name){
              return exam_data[i];
            }
        }
        return -1;
    }

     componentWillMount(){
    var that = this;
    var user = firebase.auth().currentUser;

      if (user) {
            // User is signed in.
            this.setState({logged_in:true});
      } else {
          // No user is signed in.
          this.setState({logged_in:false});
      }

  }


    render(){
   if(this.state.logged_in){
        //do nothing
    }
    else{
      return <Redirect push to="/login" />;
    }
      return (

  <Container fluid className="main-content-container px-4">
    {/* Page Header */}
    <Row noGutters className="page-header py-4">
      <PageTitle sm="4" title="Results" subtitle="Exam" className="text-sm-left" />
    </Row>

    <Row style={{marginLeft: '1%'}}>

    <div style={{height:"100%",width: '25%'}}>

     <InputGroup className="mb-3">
      <FormSelect onChange={(evt)=>{this.onClassChange(evt.target.value)}}>
        <option>{this.state.loading?"Loading...":"Select Class"}</option>
        {

                          this.state.class_list.map((item,i)=>{
                            return (<option key={i}>{item}</option>)
                          })
        }
      </FormSelect>
      <InputGroupAddon type="append">
        <InputGroupText>Class</InputGroupText>
      </InputGroupAddon>
    </InputGroup>

    </div>

    <div style={{height:"100%",width: '35%',marginLeft: '2%'}}>

     <InputGroup className="mb-3">
      <FormSelect onChange={(evt)=>{this.onExamChange(evt.target.value)}}>
        <option>{this.state.loading?"Loading...":"Select Exam Type"}</option>
        {

                          this.state.exam_list.map((item,i)=>{
                            return (<option key={i}>{item}</option>)
                          })
        }
      </FormSelect>
      <InputGroupAddon type="append">
        <InputGroupText>Exam</InputGroupText>
      </InputGroupAddon>
    </InputGroup>

    </div>

    </Row>

    <Row>
      <Col>
        <Card small className="mb-4">
          <CardHeader className="border-bottom">
              <h6 className="m-1">Examination Result</h6>
          </CardHeader>
          
          <CardBody className={"p-0 pb-3 "+(this.state.modify_result?"":"scroll_list-group")}>            

            {
            
            (!this.state.modify_result && !this.state.loading && !(this.state.selected_class==="Select Class") && !(this.state.selected_exam==="Select Exam Type")) &&
              
            <ResultTable subjects={this.state.subjects} 
                         result_data={this.state.results_data}
                         modify_result={this.modify_result}
                         selected_exam_data={()=>{return (this.get_current_exam_data()) }}
                         
                        />
          
          }

          {
            (this.state.modify_result && !this.state.loading) &&
            <div style={{height: '50%',width: '80%',marginLeft:"10%",marginTop:"5%",borderWidth: 5,borderColor: 'black'}}>
                            <ModifyResult cancel={this.ShowViewResult} 
                                          data={this.state.modify_result_data}
                                          refresh={this.get_results_data}
                                      />
            </div>
          }
          {
              
            (!this.state.loading && this.state.selected_class==="Select Class" && !this.state.modify_result ) &&

            
                    <div style={{marginTop: '10%'}} className="text-muted">
                        <div  style={{fontSize:40,textAlign: 'center',color:'blue' }}>
                          {"Please Select a Class"}
                        </div>
                        <div style={{margin: '2%',marginLeft: "0%",fontSize: 60,textAlign: 'center',color:'blue'}}>
                             <i class="material-icons">call_missed</i>  
                        </div>                  
                    </div>
          
          
          }

          {
              
            (!this.state.loading && (this.state.results_data.length===0) && (this.state.selected_class!=="Select Class") && (this.state.selected_exam!=="Select Exam Type")  && !this.state.modify_result ) &&

            
                    <div style={{marginTop: '10%'}} className="text-muted">
                        <div  style={{fontSize:40,textAlign: 'center',color:'blue' }}>
                          {"No Data Avaiable"}
                        </div>
                        <div style={{margin: '2%',marginLeft: "0%",fontSize: 60,textAlign: 'center',color:'blue'}}>
                             <i class="material-icons">warning</i>  
                        </div>                  
                    </div>
          
          
          }

          {
              
            (!this.state.loading && (this.state.selected_class!=="Select Class") && (this.state.selected_exam==="Select Exam Type")  && !this.state.modify_result ) &&

            
                    <div style={{marginTop: '10%'}} className="text-muted">
                        <div  style={{fontSize:40,textAlign: 'center',color:'blue' }}>
                          {"Please Select Exam"}
                        </div>
                        <div style={{margin: '2%',marginLeft: "0%",fontSize: 60,textAlign: 'center',color:'blue'}}>
                             <i class="material-icons">arrow_upward</i>  
                        </div>                  
                    </div>
          
          
          }

           { 
              
                  (this.state.loading) &&
                    <div style={{margin: '10%',marginLeft: '40%'}}>
                        <AtomSpinner color="blue" />            
                    </div>
          

            }

        
          </CardBody>
        </Card>
      </Col>
    </Row>
    </Container>
    )
  }
}


